export const CheckRouting = [
  {
    path: "/quality/check/list",
    name: "quality-check-list",
    meta: { title: "质量检查" },
    component: () =>
      import(/* webpackChunkName: "quality-check" */ "@/views/quality/check/list/index.vue"),
  },
  {
    hidden: true,
    path: "/quality/check/create",
    name: "quality-check-create",
    meta: { title: "新增质量检查", comName: "QualityCheckFormCreate" },
    component: () =>
      import(/* webpackChunkName: "quality-check" */ "@/views/quality/check/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/quality/check/edit/:id",
    name: "quality-check-edit",
    meta: { title: "编辑质量检查", comName: "QualityCheckFormCreate" },
    component: () =>
      import(/* webpackChunkName: "quality-check" */ "@/views/quality/check/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/quality/check/flowPrint/:id",
    name: "quality-check-print",
    meta: { title: "打印详情" },
    component: () =>
      import(/* webpackChunkName: "quality-print" */ "@/views/quality/check/form-print/index.vue"),
  },
  {
    hidden: true,
    path: "/quality/check/detail/:id",
    name: "quality-check-detail",
    meta: { title: "质量检查详情" },
    component: () =>
      import(/* webpackChunkName: "quality-check" */ "@/views/quality/check/form-detail/index.vue"),
  },
];
